import { Box, Radio, Theme, Typography } from "@material-ui/core";
import { observer } from "mobx-react";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    option: {
      display: "inline-flex",
      justifyContent: "center",
      alignItems: "center",
      padding: '4px 8px 4px 0px',
      border: "1px solid #ccc",
      borderRadius: 8,
      cursor: "pointer",
      color: "#111",
      backgroundColor: "#fff",
      marginRight: '8px',
    },
    label: {
      marginBottom: '8px'
    },
  })
);

export type RadioGroupOption = {
  label: string;
  value: string;
  checked: boolean;
  onClick: () => void;
};

type RadioGroupProps = {
  label: string;
  options: RadioGroupOption[];
};

export const RadioGroup = observer(({
  options,
  label,
}: RadioGroupProps) => {

  const classes = useStyles();

  return (
    <Box>
      <Typography variant="body1" className={classes.label}>{label}</Typography>
      <Box mb={1} fontSize={16} display={"flex"}>
        {options.map(option => (
          <Box
            onClick={() => option.onClick()}
            className={clsx(classes.option)}>
            <Radio
              checked={option.checked}
              onChange={() => { }}
              value={option.value}
              name="bg-radio"
              color="primary"
            />
            <Box component={"span"} ml={1}>{option.label}</Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
});
